import React, { useEffect } from 'react';

import { ApiParams } from '../../../common/api/api';
import { useCollapse } from '../../../common/collapse.hook';
import environment from '../../../environments';
import { Product } from '../Product.interface';
import { ProductBoardProvider } from './ProductBoard.context';
import * as Styled from './ProductBoard.styled';
import ProductBoardColumn, {
  ProductBoardColumnEntity,
  ProductBoardColumnProps
} from './ProductBoardColumn';
import ProductBoardColumnActions from './ProductBoardColumnActions';

export interface ProductBoardProps {
  product: Product;
  apiParams?: ApiParams;
}

const ProductBoard: React.FC<ProductBoardProps> = (
  props: ProductBoardProps
) => {
  const { product, apiParams } = props;
  const { items, allCollapsed, toggle, toggleAll, resetItems } = useCollapse();
  const columnProps: Omit<ProductBoardColumnProps, 'entity'> = {
    product,
    apiParams,
    collapsed: items[0]
  };

  useEffect(() => {
    resetItems(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProductBoardProvider>
      <Styled.ProductBoard className='product-board'>
        <ProductBoardColumnActions
          collapsed={items[0]}
          headerCollapsed={allCollapsed}
          hideHeader={columnProps.hideHeader}
          onToggleAll={toggleAll}
          onToggle={() => toggle(0)}
        />
        <ProductBoardColumn
          {...columnProps}
          entity={ProductBoardColumnEntity.UserNeed}
        />
        <ProductBoardColumn
          {...columnProps}
          entity={ProductBoardColumnEntity.DesignInput}
        />
        <ProductBoardColumn
          {...columnProps}
          entity={ProductBoardColumnEntity.DesignOutput}
        />
        <ProductBoardColumn
          {...columnProps}
          entity={ProductBoardColumnEntity.Verification}
        />
        <ProductBoardColumn
          {...columnProps}
          entity={ProductBoardColumnEntity.Validation}
        />
        {environment.productConfig?.designSpec && (
          <ProductBoardColumn
            {...columnProps}
            entity={ProductBoardColumnEntity.DesignSpec}
          />
        )}
      </Styled.ProductBoard>
    </ProductBoardProvider>
  );
};

export default ProductBoard;
